import { Component, Input, OnInit } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';

@Component({
  selector: 'ngx-modal-aviso',
  templateUrl: './modal-aviso.component.html',
  styleUrls: ['./modal-aviso.component.scss']
})
export class ModalAvisoComponent implements OnInit {

  @Input() titulo: string = 'Aviso importante';
  @Input() mensagem: string;
  @Input() labelBotao: string = 'OK, ENTENDI';

  public customLogin = null;

  constructor(protected ref: NbDialogRef<ModalAvisoComponent>) { }

  ngOnInit() {
    let resCustom = localStorage.getItem('bway-customLogin');
    this.customLogin = JSON.parse(resCustom);
  }

  fechar() {
    this.ref.close();
  }

  getButtonPrimaria() {
    return this.customLogin ? this.customLogin.primaria : null;
  }
}
